/* eslint-disable react/no-unused-prop-types */
import { Box } from '@mui/material'
import React, { ReactNode } from 'react'
import { useFeatureFlag } from '../../../utils/hooks/useFeatureFlag'

interface WizardStepProps {
  children: ReactNode
  handleBack?: (params: unknown) => unknown
  handleDone?: (params: unknown) => unknown
  handleNext?: (params: unknown) => unknown
  handleSave?: (params: unknown) => unknown
}

const WizardStep = ({ children }: WizardStepProps) => {
  const userRedesignFeatureEnabled = useFeatureFlag('UserProfile_Redesign')

  return (
    <Box
      className="RsmWizardStep-root"
      style={
        userRedesignFeatureEnabled ? { height: 'calc(100% - 1rem)' } : undefined
      }>
      {children}
    </Box>
  )
}

export default WizardStep
